<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="学期">
              <el-select v-model="selectedSemesterId" placeholder="学期" class="toolbar-field-w-lg" :disabled="!schoolId"
                @change="handleQuery">
                <el-option v-for="s in semesterList" :key="semesterId(s)" :label="semesterName(s)"
                  :value="semesterId(s)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" :disabled="!schoolId" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="toolbarBtnType(item)"
              :icon="toolbarBtnIcon(item)"
              :loading="!!item.loading"
              @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
        <p class="hv-tip">{{ filterTipText }}</p>
      </div>

      <div v-if="schoolId && isNarrowScope && scopeLabel && activeTab === 'class'" class="hv-scope-tip">
        当前范围：{{ scopeLabel }}
        <el-button type="text" @click="clearScope">查看全校</el-button>
      </div>

      <template v-if="!schoolId">
        <div class="hv-empty">请在左侧选择学校</div>
      </template>
      <template v-else-if="!selectedSemesterId">
        <div class="hv-empty">请选择学期后查询</div>
      </template>
      <template v-else>
        <div v-if="statistics" class="hv-stat-grid">
          <div v-for="(card, idx) in summaryCards" :key="idx" class="hv-stat-item"
            :class="'hv-stat-item--' + card.theme">
            <div class="hv-stat-value">{{ formatSummaryValue(card) }}</div>
            <div class="hv-stat-name">{{ card.name }}</div>
          </div>
        </div>

        <el-tabs v-model="activeTab" class="hv-stat-tabs">
          <el-tab-pane label="班级统计" name="class">
            <div class="tbl-scroll-host">
              <el-table ref="classStatTable" v-loading="loading" :data="displayClassStats" stripe size="small"
                height="100%" style="width: 100%;" empty-text="暂无班级数据">
                <el-table-column prop="GradeName" label="年级" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ClassName" label="班级" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="StudentTotal" label="学生数" min-width="90" align="center"></el-table-column>
                <el-table-column prop="FirstVisitDoneCount" label="首次完成" min-width="90" align="center"></el-table-column>
                <el-table-column label="完成率" min-width="120" align="center">
                  <template slot-scope="scope">
                    <span class="hv-rate-text">{{ scope.row.FirstVisitDoneRate }}%</span>
                    <el-progress :percentage="Number(scope.row.FirstVisitDoneRate) || 0" :show-text="false"
                      :stroke-width="6" class="hv-rate-bar"></el-progress>
                  </template>
                </el-table-column>
                <el-table-column prop="FollowUpVisitCount" label="回访次数" min-width="100" align="center"></el-table-column>
                <el-table-column label="操作" width="110" align="center" class-name="hv-table-action-col">
                  <template slot-scope="scope">
                    <el-button type="text" class="hv-action-btn" @click="openClassDetail(scope.row)">明细</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-col v-if="classStatsTotal > 0" :span="24" class="toolbar">
              <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="page"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="classStatsTotal" style="float: right"
                @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
            </el-col>
          </el-tab-pane>

          <el-tab-pane label="教师统计" name="teacher">
            <div class="tbl-scroll-host">
              <el-table ref="teacherStatTable" v-loading="loading" :data="displayTeacherStats" stripe size="small"
                height="100%" style="width: 100%;" empty-text="暂无教师数据">
                <el-table-column prop="TeacherName" label="教师" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CardNumber" label="卡号" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="FirstVisitCount" label="首次家访" min-width="90" align="center"></el-table-column>
                <el-table-column prop="FollowUpVisitCount" label="回访次数" min-width="90" align="center"></el-table-column>
                <el-table-column prop="TotalVisitCount" label="家访总次数" min-width="100" align="center"></el-table-column>
                <el-table-column label="最近家访" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">{{ formatDateTime(scope.row.LastVisitTime) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="110" align="center" class-name="hv-table-action-col">
                  <template slot-scope="scope">
                    <el-button type="text" class="hv-action-btn" @click="openTeacherDetail(scope.row)">明细</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-col v-if="teacherStatsTotal > 0" :span="24" class="toolbar">
              <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="teacherPage"
                :page-sizes="[10, 20, 50, 100]" :page-size="teacherPageSize" :total="teacherStatsTotal"
                style="float: right" @size-change="handleTeacherSizeChange"
                @current-change="handleTeacherPageChange"></el-pagination>
            </el-col>
          </el-tab-pane>
        </el-tabs>
      </template>

      <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" width="720px"
        custom-class="hv-class-detail-dialog" @closed="resetClassDetail" @opened="layoutTable('classDetailTable')">
        <div class="hv-detail-filter">
          <el-radio-group v-model="detailFilter" size="small" @change="handleDetailFilterChange">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="done">已完成首次</el-radio-button>
            <el-radio-button label="pending">未完成首次</el-radio-button>
          </el-radio-group>
          <span class="hv-detail-count">共 {{ detailTotal }} 人</span>
        </div>
        <el-table ref="classDetailTable" v-loading="detailLoading" :data="detailStudents" stripe size="small"
          class="hv-detail-table" style="width: 100%;" empty-text="暂无数据">
          <el-table-column prop="StudentName" label="姓名" min-width="86" show-overflow-tooltip></el-table-column>
          <el-table-column prop="CardNumber" label="卡号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="StudentCode" label="学号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="首次家访" min-width="92" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.FirstVisitDone ? 'success' : 'info'" size="mini">
                {{ scope.row.FirstVisitDone ? '已完成' : '未完成' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="VisitCount" label="家访次数" min-width="86" align="center"></el-table-column>
          <el-table-column label="最近家访" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatDateTime(scope.row.LastVisitTime) }}</template>
          </el-table-column>
        </el-table>
        <div class="hv-detail-pager">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="detailPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="detailPageSize"
            :total="detailTotal"
            @size-change="handleDetailSizeChange"
            @current-change="handleDetailPageChange"
          />
        </div>
        <div slot="footer" class="hv-detail-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="teacherDetailDialogTitle" :visible.sync="teacherDetailDialogVisible" width="820px"
        custom-class="hv-teacher-detail-dialog" @closed="resetTeacherDetail"
        @opened="layoutTable('teacherDetailTable')">
        <div class="hv-detail-filter">
          <el-radio-group v-model="teacherDetailFilter" size="small" @change="handleTeacherDetailFilterChange">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="first">首次家访</el-radio-button>
            <el-radio-button label="follow">回访</el-radio-button>
          </el-radio-group>
          <span class="hv-detail-count">共 {{ teacherDetailTotal }} 条</span>
        </div>
        <el-table ref="teacherDetailTable" v-loading="teacherDetailLoading" :data="teacherDetailRows" stripe
          size="small" class="hv-detail-table" style="width: 100%;" empty-text="暂无家访记录">
          <el-table-column prop="GradeName" label="年级" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ClassName" label="班级" min-width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="StudentName" label="学生" min-width="86" show-overflow-tooltip></el-table-column>
          <el-table-column prop="StudentCode" label="学号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="类型" min-width="88" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.VisitType === 2 ? 'warning' : 'success'" size="mini">
                {{ visitTypeLabel(scope.row.VisitType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="家访时间" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatDateTime(scope.row.VisitTime) }}</template>
          </el-table-column>
          <el-table-column prop="Address" label="地址" min-width="120" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="hv-detail-pager">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="teacherDetailPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="teacherDetailPageSize"
            :total="teacherDetailTotal"
            @size-change="handleTeacherDetailSizeChange"
            @current-change="handleTeacherDetailPageChange"
          />
        </div>
        <div slot="footer" class="hv-detail-footer">
          <el-button @click="teacherDetailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import toolbarFilterBarMixin from "@/mixins/toolbarFilterBarMixin";
import {
  getHomeVisitStatistics,
  getHomeVisitClassStudentProgress,
  getHomeVisitTeacherVisitDetail,
  exportHomeVisitSummary,
  downloadBlobExcel,
  loadHomeVisitSemesterList,
  resolveHomeVisitSchoolIdFromTreeNode,
  isHomeVisitNarrowScopeNode,
  homeVisitSemesterId,
  homeVisitSemesterName,
  visitTypeText
} from "@/api/homeVisit";

export default {
  mixins: [toolbarFilterBarMixin],
  components: { DepartmentPane },
  data() {
    return {
      DepartmentId: 0,
      schoolId: 0,
      scopeDepartmentId: 0,
      scopeLabel: "",
      isNarrowScope: false,
      semesterList: [],
      selectedSemesterId: null,
      statistics: null,
      loading: false,
      activeTab: "class",
      page: 1,
      pageSize: 10,
      teacherPage: 1,
      teacherPageSize: 10,
      buttonList: [],
      actionButtonList: [],
      detailDialogVisible: false,
      detailLoading: false,
      detailFilter: "all",
      detailClassRow: null,
      detailStudents: [],
      detailPage: 1,
      detailPageSize: 10,
      detailTotal: 0,
      teacherDetailDialogVisible: false,
      teacherDetailLoading: false,
      teacherDetailFilter: "all",
      teacherDetailRow: null,
      teacherDetailRows: [],
      teacherDetailPage: 1,
      teacherDetailPageSize: 10,
      teacherDetailTotal: 0
    };
  },
  watch: {
    activeTab() {
      this.layoutTable(this.activeTab === "teacher" ? "teacherStatTable" : "classStatTable");
    }
  },
  computed: {
    filterTipText() {
      if (this.activeTab === "teacher") {
        return "按学期汇总全校教师家访完成情况，不受左侧部门范围影响，支持导出 Excel。";
      }
      return "按学期汇总家访完成情况；可在左侧部门树选择学校/校区/学部/年级/班级缩小统计范围，支持导出 Excel。";
    },
    detailDialogTitle() {
      if (!this.detailClassRow) return "学生明细";
      const grade = this.detailClassRow.GradeName || "";
      const cls = this.detailClassRow.ClassName || "";
      return `学生明细 - ${grade}${grade && cls ? " " : ""}${cls}`;
    },
    classStats() {
      return (this.statistics && this.statistics.ClassStats) ? this.statistics.ClassStats : [];
    },
    classStatsTotal() {
      return this.classStats.length;
    },
    displayClassStats() {
      const start = (this.page - 1) * this.pageSize;
      return this.classStats.slice(start, start + this.pageSize);
    },
    teacherStats() {
      return (this.statistics && this.statistics.TeacherStats) ? this.statistics.TeacherStats : [];
    },
    teacherStatsTotal() {
      return this.teacherStats.length;
    },
    displayTeacherStats() {
      const start = (this.teacherPage - 1) * this.teacherPageSize;
      return this.teacherStats.slice(start, start + this.teacherPageSize);
    },
    teacherDetailDialogTitle() {
      if (!this.teacherDetailRow) return "教师家访明细";
      return `教师家访明细 - ${this.teacherDetailRow.TeacherName || ""}`;
    },
    summaryCards() {
      if (this.activeTab === "teacher") {
        const list = this.teacherStats;
        const visitedCount = list.filter((t) => (t.TotalVisitCount || 0) > 0).length;
        const totalVisits = list.reduce((sum, t) => sum + (t.TotalVisitCount || 0), 0);
        const followUpVisits = list.reduce((sum, t) => sum + (t.FollowUpVisitCount || 0), 0);
        return [
          { value: list.length, name: "教师总数", theme: "blue" },
          { value: visitedCount, name: "已家访教师", theme: "green" },
          { value: totalVisits, name: "家访总次数", theme: "orange" },
          { value: followUpVisits, name: "回访总次数", theme: "purple" }
        ];
      }
      const summary = this.statistics && this.statistics.Summary;
      return [
        { value: summary ? summary.StudentTotal : 0, name: "学生总数", theme: "blue" },
        { value: summary ? summary.FirstVisitDoneCount : 0, name: "已完成首次家访", theme: "green" },
        { value: summary ? summary.FirstVisitDoneRate : 0, name: "首次完成率", theme: "orange", suffix: "%" },
        { value: summary ? summary.FollowUpVisitCount : 0, name: "回访总次数", theme: "purple" }
      ];
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.buttonList = buttonList;
    this.actionButtonList = (buttonList || []).filter((b) => b.Func !== "handleQuery");
  },
  methods: {
    semesterId: homeVisitSemesterId,
    semesterName: homeVisitSemesterName,
    visitTypeLabel: visitTypeText,

    formatSummaryValue(card) {
      if (!card) return 0;
      const val = card.value != null ? card.value : 0;
      return card.suffix ? `${val}${card.suffix}` : val;
    },

    buildScopeParams() {
      const params = {};
      if (this.isNarrowScope && this.scopeDepartmentId) {
        params.scopeDepartmentId = this.scopeDepartmentId;
      }
      return params;
    },

    teacherDetailVisitType() {
      if (this.teacherDetailFilter === "first") return 1;
      if (this.teacherDetailFilter === "follow") return 2;
      return null;
    },

    async loadTeacherDetailRows() {
      if (!this.teacherDetailRow || !this.schoolId || !this.selectedSemesterId) return;
      const teacherMasterId = this.teacherDetailRow.TeacherMasterId || this.teacherDetailRow.teacherMasterId;
      const teacherUid = this.teacherDetailRow.TeacherUid || this.teacherDetailRow.teacherUid;

      this.teacherDetailLoading = true;
      try {
        if (!teacherMasterId && !teacherUid) {
          this.teacherDetailRows = [];
          this.teacherDetailTotal = 0;
          return;
        }

        const params = {
          schoolDepartmentId: this.schoolId,
          semesterId: this.selectedSemesterId,
          page: this.teacherDetailPage,
          pageSize: this.teacherDetailPageSize
        };

        if (teacherMasterId) {
          params.teacherMasterId = teacherMasterId;
        } else {
          params.teacherUid = teacherUid;
        }

        const visitType = this.teacherDetailVisitType();
        if (visitType != null) {
          params.visitType = visitType;
        }

        const res = await getHomeVisitTeacherVisitDetail(params);
        const d = res.data;
        if (d.success && d.response) {
          const page = d.response;
          this.teacherDetailRows = page.data || page.Data || [];
          this.teacherDetailTotal = page.dataCount != null ? page.dataCount : (page.DataCount || 0);
        } else {
          this.teacherDetailRows = [];
          this.teacherDetailTotal = 0;
          this.$message.error(d.msg || "加载明细失败");
        }
      } finally {
        this.teacherDetailLoading = false;
        this.layoutTable("teacherDetailTable");
      }
    },

    openTeacherDetail(row) {
      if (!row) return;
      this.teacherDetailRow = row;
      this.teacherDetailFilter = "all";
      this.teacherDetailPage = 1;
      this.teacherDetailRows = [];
      this.teacherDetailTotal = 0;
      this.teacherDetailDialogVisible = true;
      this.loadTeacherDetailRows();
    },

    handleTeacherDetailFilterChange() {
      this.teacherDetailPage = 1;
      this.loadTeacherDetailRows();
    },

    handleTeacherDetailSizeChange(val) {
      this.teacherDetailPageSize = val;
      this.teacherDetailPage = 1;
      this.loadTeacherDetailRows();
    },

    handleTeacherDetailPageChange(val) {
      this.teacherDetailPage = val;
      this.loadTeacherDetailRows();
    },

    resetTeacherDetail() {
      this.teacherDetailRow = null;
      this.teacherDetailRows = [];
      this.teacherDetailFilter = "all";
      this.teacherDetailPage = 1;
      this.teacherDetailTotal = 0;
      this.teacherDetailLoading = false;
    },

    handleTeacherPageChange(val) {
      this.teacherPage = val;
    },

    handleTeacherSizeChange(val) {
      this.teacherPageSize = val;
      this.teacherPage = 1;
    },

    formatDateTime(val) {
      if (!val) return "—";
      return String(val).replace("T", " ").substring(0, 16);
    },

    layoutTable(refName) {
      this.$nextTick(() => {
        const run = () => {
          const table = this.$refs[refName];
          if (table && typeof table.doLayout === "function") {
            table.doLayout();
          }
        };
        run();
        setTimeout(run, 80);
      });
    },

    async openClassDetail(row) {
      if (!row || !row.ClassDepartmentId || !this.schoolId || !this.selectedSemesterId) return;
      this.detailClassRow = row;
      this.detailFilter = "all";
      this.detailPage = 1;
      this.detailStudents = [];
      this.detailTotal = 0;
      this.detailDialogVisible = true;
      this.loadClassDetailRows();
    },

    /** 加载班级学生明细分页。最后更新：2026-09-01 */
    async loadClassDetailRows() {
      if (!this.detailClassRow || !this.schoolId || !this.selectedSemesterId) return;
      this.detailLoading = true;
      try {
        const res = await getHomeVisitClassStudentProgress({
          schoolDepartmentId: this.schoolId,
          classDepartmentId: this.detailClassRow.ClassDepartmentId,
          semesterId: this.selectedSemesterId,
          firstVisitFilter: this.detailFilter || "all",
          page: this.detailPage,
          pageSize: this.detailPageSize
        });
        const d = res.data;
        if (d.success && d.response) {
          const page = d.response;
          this.detailStudents = page.data || page.Data || [];
          this.detailTotal = page.dataCount != null ? page.dataCount : (page.DataCount || 0);
        } else {
          this.detailStudents = [];
          this.detailTotal = 0;
          this.$message.error(d.msg || "加载明细失败");
        }
      } finally {
        this.detailLoading = false;
        this.layoutTable("classDetailTable");
      }
    },

    handleDetailFilterChange() {
      this.detailPage = 1;
      this.loadClassDetailRows();
    },

    handleDetailSizeChange(val) {
      this.detailPageSize = val;
      this.detailPage = 1;
      this.loadClassDetailRows();
    },

    handleDetailPageChange(val) {
      this.detailPage = val;
      this.loadClassDetailRows();
    },

    resetClassDetail() {
      this.detailClassRow = null;
      this.detailStudents = [];
      this.detailFilter = "all";
      this.detailPage = 1;
      this.detailTotal = 0;
      this.detailLoading = false;
    },

    async treeNodeClick(data, node) {
      const newSchoolId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
      const schoolChanged = newSchoolId !== this.schoolId;
      this.isNarrowScope = isHomeVisitNarrowScopeNode(node);
      this.scopeDepartmentId = data.value;
      this.scopeLabel = this.isNarrowScope ? (data.label || data.name || "") : "";
      this.DepartmentId = newSchoolId || data.value;
      this.schoolId = newSchoolId;
      this.page = 1;
      this.teacherPage = 1;
      if (schoolChanged) {
        this.selectedSemesterId = null;
        this.semesterList = [];
        this.statistics = null;
      }
      await loadHomeVisitSemesterList(this, this.schoolId || this.DepartmentId);
      await this.loadStatistics();
    },

    clearScope() {
      if (!this.schoolId) return;
      this.scopeDepartmentId = this.schoolId;
      this.scopeLabel = "";
      this.isNarrowScope = false;
      this.page = 1;
      this.teacherPage = 1;
      this.loadStatistics();
    },

    handleQuery() {
      this.page = 1;
      this.teacherPage = 1;
      this.loadStatistics();
    },

    handlePageChange(val) {
      this.page = val;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
    },

    async loadStatistics() {
      if (!this.schoolId || !this.selectedSemesterId) {
        this.statistics = null;
        return;
      }
      this.loading = true;
      try {
        const params = {
          schoolDepartmentId: this.schoolId,
          semesterId: this.selectedSemesterId
        };
        if (this.isNarrowScope && this.scopeDepartmentId) {
          params.scopeDepartmentId = this.scopeDepartmentId;
        }
        const res = await getHomeVisitStatistics(params);
        const d = res.data;
        if (d.success) {
          this.statistics = d.response;
          this.page = 1;
          this.teacherPage = 1;
          this.layoutTable(this.activeTab === "teacher" ? "teacherStatTable" : "classStatTable");
        } else {
          this.statistics = null;
          this.$message.error(d.msg || "加载失败");
        }
      } finally {
        this.loading = false;
      }
    },

    btnClick(item) {
      if (!item || !item.Func) return;
      if (typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },

    handleExport() {
      if (!this.schoolId || !this.selectedSemesterId) {
        this.$message.warning("请先选择学校与学期");
        return;
      }
      const params = {
        schoolDepartmentId: this.schoolId,
        semesterId: this.selectedSemesterId
      };
      if (this.isNarrowScope && this.scopeDepartmentId) {
        params.scopeDepartmentId = this.scopeDepartmentId;
      }
      exportHomeVisitSummary(params)
        .then((res) => downloadBlobExcel(res, "家访汇总"))
        .catch(() => this.$message.error("导出失败"));
    }
  }
};
</script>

<style scoped>
.hv-scope-tip {
  flex: 0 0 auto;
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #f4f7fc;
  border-radius: 6px;
}

.hv-tip {
  color: #909399;
  font-size: 13px;
  margin: 0;
  line-height: 1.5;
}

.hv-empty {
  flex: 0 0 auto;
  color: #909399;
  padding: 48px 0;
  text-align: center;
  font-size: 14px;
}

.hv-stat-grid {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.hv-stat-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  text-align: left;
  border: 1px solid #ebeef5;
  background: #f8fafc;
  min-height: 0;
}

.hv-stat-value {
  order: 2;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.hv-stat-name {
  order: 1;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 12px;
  color: #909399;
  margin-top: 0;
  line-height: 1.3;
}

.hv-stat-item--blue .hv-stat-value {
  color: var(--btn-primary, #2563eb);
}

.hv-stat-item--green .hv-stat-value {
  color: #67c23a;
}

.hv-stat-item--orange .hv-stat-value {
  color: #e6a23c;
}

.hv-stat-item--purple .hv-stat-value {
  color: #9b59b6;
}

.hv-stat-tabs {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}

.hv-stat-tabs>>>.el-tabs__header {
  flex-shrink: 0;
  margin-bottom: 8px;
}

.hv-stat-tabs>>>.el-tabs__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.hv-stat-tabs>>>.el-tab-pane {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.hv-stat-tabs>>>.el-tab-pane > .tbl-scroll-host {
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  overflow: hidden;
}

.hv-stat-tabs>>>.el-tab-pane > .el-col.toolbar {
  flex: 0 0 auto;
  margin-top: 8px;
}

.hv-tab-tip {
  margin: 0 0 10px;
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}

.hv-stat-tabs>>>td.hv-table-action-col .cell {
  white-space: nowrap;
  overflow: visible;
}

.hv-stat-tabs>>>.hv-action-btn {
  padding: 0 4px;
  white-space: nowrap;
  text-decoration: none !important;
}

.hv-stat-tabs>>>.hv-action-btn span {
  text-decoration: none !important;
}

.hv-rate-text {
  display: inline-block;
  min-width: 36px;
  font-size: 13px;
  color: #606266;
  margin-right: 8px;
  vertical-align: middle;
}

.hv-rate-bar {
  display: inline-block;
  width: calc(100% - 48px);
  max-width: 120px;
  vertical-align: middle;
}

.hv-detail-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.hv-detail-count {
  font-size: 13px;
  color: #909399;
}

@media (max-width: 960px) {
  .hv-stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

<style>
.hv-class-detail-dialog .el-dialog__body,
.hv-teacher-detail-dialog .el-dialog__body {
  padding-top: 12px;
  padding-bottom: 16px;
}

.hv-class-detail-dialog .hv-detail-table,
.hv-teacher-detail-dialog .hv-detail-table {
  width: 100%;
}

.hv-class-detail-dialog .hv-detail-pager,
.hv-teacher-detail-dialog .hv-detail-pager {
  width: 100%;
  margin-top: 12px;
  text-align: right;
  overflow: hidden;
}

.hv-class-detail-dialog .hv-detail-pager .el-pagination,
.hv-teacher-detail-dialog .hv-detail-pager .el-pagination {
  display: inline-block;
  vertical-align: top;
  padding: 0;
  margin: 0;
  box-shadow: none;
}

.hv-class-detail-dialog .hv-detail-footer,
.hv-teacher-detail-dialog .hv-detail-footer {
  text-align: right;
}

.hv-class-detail-dialog .el-dialog__footer,
.hv-teacher-detail-dialog .el-dialog__footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #ebeef5;
}
</style>
